import { Component, OnInit, ViewChild } from '@angular/core';
import { AppInformationService, ArkUnitOfWork, AuthService, UtilityService } from 'app/core/core.module';
import { BankTransaction, Contribution, ContributionLine } from 'app/core/model/entity-model';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { DxDataGridComponent } from 'devextreme-angular';
import { alert, confirm } from 'devextreme/ui/dialog';
import { environment } from 'environments/environment';
import _ from 'lodash';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { OnlineSummaryDialogComponent } from '../online-summary-dialog/online-summary-dialog.component';
import { GivingService } from 'app/core/data/giving.service';

@Component({
    selector: 'app-online-contributions',
    templateUrl: './online-contributions.component.html',
    styleUrls: ['./online-contributions.component.scss'],
    standalone: false,
})
export class OnlineContributionsComponent implements OnInit {
    contributions: any[];
    contribution: ContributionItem;

    months = [
        { id: 1, name: 'January' },
        { id: 2, name: 'February' },
        { id: 3, name: 'March' },
        { id: 4, name: 'April' },
        { id: 5, name: 'May' },
        { id: 6, name: 'June' },
        { id: 7, name: 'July' },
        { id: 8, name: 'August' },
        { id: 9, name: 'September' },
        { id: 10, name: 'October' },
        { id: 11, name: 'November' },
        { id: 12, name: 'December' },
    ];
    selectedMonthId: number;
    givingTypes: any[];
    people: any[];
    types: any[];
    otherAccounts: any[];

    specialAccountId: number;
    batchId: number;
    saveEnable = true;
    addProcessing = false;
    processing = false;
    bankAmounts: any[];
    bankEntry: any;
    fee = 0.0;
    cloverTotal = 0.0;
    previousBatches: any;
    previousBatch: any;
    yearValue: any;

    serviceName = environment.serviceName;
    bankTotal = 0.0;
    currentMonthTotal = 0.0;
    nextMonthTotal = 0.0;
    lastMonthTotal = 0.0;
    selectedSum = 0.0;

    givingPath: string;
    bankPath: string;
    dataReturned = false;
    autoAssignComplete = false;
    canDelete = false;
    bankIds: any[];
    uploadHeaders: any;

    @ViewChild('personSelect') personSelect: any;
    @ViewChild('bankSelect') bankSelect: any;
    @ViewChild('contributionsGrid') contributionsGrid: DxDataGridComponent;
    @ViewChild('currentGrid') currentGrid: DxDataGridComponent;
    @ViewChild('nextGrid') nextGrid: DxDataGridComponent;
    @ViewChild('bankGrid') bankGrid: DxDataGridComponent;

    constructor(
        private uow: ArkUnitOfWork,
        public appInfo: AppInformationService,
        private modalService: BsModalService,
        private auth: AuthService,
        private utility: UtilityService,
        private givingService: GivingService
    ) {}

    async ngOnInit() {
        this.uploadHeaders = { Authorization: 'Bearer ' + this.auth.currentUser.jwtToken };
        this.bankEntry = {};

        // await this.getData(true);
        this.bankAmounts = [];
        this.contributions = [];
        this.people = await this.uow.getPeopleForGiving();
        this.types = await this.uow.getContributionTypes();
        this.previousBatches = await this.uow.getPreviousCloverCarryovers();
        this.previousBatch = this.previousBatches[0];
        this.otherAccounts = this.uow.otherAccounts();

        this.contribution = new ContributionItem();
        this.contribution.givingTypeId = 4;
        this.canDelete = this.auth.currentUser.userName === 'mreimink';
    }

    async retrieveData() {
        await this.getData();
    }

    async getData(refresh?: boolean) {
        this.appInfo.pleaseWaitShow();
        await this.getBankAmounts();
        await this.getGivingAmounts();

        this.calculateTotals();
        this.appInfo.pleaseWaitHide();
        this.dataReturned = true;
    }

    async getBankAmounts() {
        if (!this.selectedMonthId) return;
        const startDate = moment(this.getAssignedMonth()).add(1, 'days').toDate();
        this.bankAmounts = (await this.uow.getBankTransactions(startDate)) as BankTransaction[];
        this.bankAmounts.forEach((bankAmount) => {
            bankAmount.amount = !!bankAmount.credit ? bankAmount.credit : bankAmount.debit ? bankAmount.debit * -1 : 0;
        });
        this.bankIds = this.bankAmounts.map((x) => {
            return x.id;
        });
    }

    async getGivingAmounts() {
        if (!this.selectedMonthId) return;
        this.contributions = (await this.uow.getOnlineGivingAmounts()) as any;
    }

    calculateTotals() {
        this.bankTotal = 0;
        this.currentMonthTotal = 0;
        this.nextMonthTotal = 0;
        this.lastMonthTotal = 0;

        this.bankAmounts.forEach((x) => {
            x.postDate = moment(x.postDate).toDate();
            this.bankTotal += Number(x.amount);
        });
        this.contributions.forEach((x) => {
            x.donationDate = moment(x.donationDate).toDate();
            if (x.currentMonth) this.currentMonthTotal += Number(x.grossGift);
            if (x.nextMonth && !x.contributionId) this.nextMonthTotal += Number(x.grossGift);
            if (x.nextMonth && !!x.contributionId) this.lastMonthTotal += Number(x.grossGift);
        });

        this.bankTotal = Math.round((this.bankTotal + Number.EPSILON) * 100) / 100;
        this.currentMonthTotal = Math.round((this.currentMonthTotal + Number.EPSILON) * 100) / 100;
        this.nextMonthTotal = Math.round((this.nextMonthTotal + Number.EPSILON) * 100) / 100;
        this.lastMonthTotal = Math.round((this.lastMonthTotal + Number.EPSILON) * 100) / 100;
        this.fee = Math.round((this.fee + Number.EPSILON) * 100) / 100;
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            }
        );
    }
    onToolbarPreparingBank(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            }
        );
    }
    rowPrepare(e) {
        if (e.rowType === 'data') {
            if (!e.data.personId) {
                e.rowElement.className = e.rowElement.className + ' noPerson';
            }
            if (e.data.bankTransactionId) {
                e.rowElement.className = e.rowElement.className + ' linked-bank';
            }
        }
    }
    rowPrepareBank(e) {
        if (e.rowType === 'data') {
            if (e.data.amount <= 0) {
                e.rowElement.className = e.rowElement.className + ' noPerson';
            }
            if (!!e.data.onlineContributions && e.data.onlineContributions.length > 0) {
                e.rowElement.className = e.rowElement.className + ' negative-bank';
            }
        }
    }
    bankRowDoubleClick(e) {
        if (e.rowType === 'data') {
            if (e.data.amount <= 0) {
                this.fee = e.data.amount;
                // this.linkFee(e.data.id);  //needs to not be a getter on the entities file
            }
            if (e.data.amount > 0) {
                this.link();
            }
        }
    }

    linkFee(id: number) {
        const fee = _.find(this.bankAmounts, { id: id });
        fee.contributionList = 'Linked';
        console.log(fee);
    }

    onSelectionChange(e) {
        this.selectedSum = 0;
        if (e.rowType === 'data') {
            if (!!e.data.currentMonth) {
                e.rowElement.className = e.rowElement.className + ' currentMonth-grid ';
            }
            if (!!e.data.nextMonth) {
                e.rowElement.className = e.rowElement.className + ' nextMonth-grid ';
            }
        }
        const selectedRows = this.contributionsGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;
        selectedRows.forEach((row) => {
            this.selectedSum += row.grossGift;
        });
    }

    async autoAssign() {
        this.appInfo.pleaseWaitShow();
        const bankTransactions = _.sortBy(this.bankAmounts, 'postDate');
        console.log(bankTransactions);
        for (let index = 0; index < this.bankAmounts.length; index++) {
            const bank = this.bankAmounts[index];
            // console.log('id', bank.id);
            if (bank.amount < 0) continue;
            let matchAmount = 0;
            let contributions = [];

            const sortedContributions = _.sortBy(this.contributions, 'donationDate');
            for (let index = 0; index < sortedContributions.length; index++) {
                const contribution = sortedContributions[index];
                console.log('cont-id', contribution.id);
                if (!contribution.bankTransactionId) {
                    matchAmount += contribution.grossGift;
                    // console.log('matchAmount', matchAmount);
                    contributions.push(contribution);
                    if (matchAmount.toFixed(2) === Number(bank.amount).toFixed(2)) {
                        contributions.forEach((x) => {
                            x.bankTransactionId = bank.id;
                        });
                        break;
                    }
                }
            }
        }
        this.autoAssignComplete = true;
        this.appInfo.pleaseWaitHide();
    }

    async deleteContribution() {
        const selectedRow = this.contributionsGrid.instance.getSelectedRowsData();
        if (!selectedRow) return;
        selectedRow.forEach((row) => {
            row.deleted = new Date();
        });
        await this.uow.commit();
        this.contributionsGrid.instance.clearSelection();
        await this.getGivingAmounts();
    }

    async delete() {
        const result = await confirm(`Are you sure you want to clear all data?`, `${this.appInfo.settings.church.toUpperCase()}`);
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        for (let index = 0; index < this.bankAmounts.length; index++) {
            const x = this.bankAmounts[index];
            if (x.onlineContributions && x.onlineContributions.length > 0) {
                _.forEachRight(x.onlineContributions, (contribution) => {
                    contribution.bankTransactionId = null;
                    contribution.processed = null;
                });
            }
        }
        await this.uow.commit();

        this.bankAmounts.forEach((x) => {
            if (!x.processed) x.deleted = new Date();
        });
        this.contributions.forEach((x) => {
            if (!x.processed) {
                if (x.nextMonth) {
                    x.bankTransactionId = null;
                } else {
                    x.deleted = new Date();
                }
            }
        });
        await this.uow.commit();
        await this.getData();
        this.calculateTotals();
        this.appInfo.pleaseWaitHide();
    }

    addBankAmount() {
        this.bankEntry.id = this.bankAmounts.length > 0 ? _.maxBy(this.bankAmounts, 'id').id + 1 : 1;
        this.bankAmounts.push({ id: this.bankEntry.id, amount: this.bankEntry.amount });
        this.bankEntry.amount = null;
        this.calculateTotals();
        setTimeout(() => {
            this.bankSelect.instance.focus();
        });
    }

    deleteBankAmount() {
        let selectedRow = null;
        let selectedKey = null;

        selectedRow = this.bankGrid.instance.getSelectedRowsData()[0];
        selectedKey = selectedRow.id;

        this.bankAmounts.splice(_.findIndex(this.bankAmounts, { id: selectedKey }), 1);
        this.bankGrid.instance.clearSelection();
        this.bankGrid.instance.refresh();
        this.calculateTotals();
    }

    async setMonth(month: string) {
        this.appInfo.pleaseWaitShow();
        const selectedRows = this.contributionsGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        const rowCheck = _.every(selectedRows, { bankTransactionId: null });
        if (!rowCheck && month !== 'current') {
            this.appInfo.pleaseWaitHide();
            const result = await confirm(
                `Lines with bank links shouldn't be marked as Next Month.  Are you sure you meant to do this?`,
                `${this.appInfo.settings.church.toUpperCase()}`
            );
            if (!result) return;
        }

        await selectedRows.forEach(async (row) => {
            if (month === 'current') {
                row.currentMonth = true;
                row.nextMonth = false;
            } else {
                row.currentMonth = false;
                row.nextMonth = true;
            }
        });
        await this.uow.commit();
        this.contributionsGrid.instance.clearSelection();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async envelopeChanged(e) {
        if (!this.contribution.envelope) return;
        let persons = _(this.people).find(((user) => {
            return user.envelope === this.contribution.envelope && user.sex === 'M';
        }) as any) as any;
        if (!!persons) this.contribution.personId = persons.id;
        else {
            persons = _(this.people).find(((user) => {
                return user.envelope === this.contribution.envelope;
            }) as any) as any;
            if (!!persons) this.contribution.personId = persons.id;
            else this.contribution.personId = 3794;
        }
    }

    getAssignedMonth(): string {
        const today = new Date();
        if (!this.selectedMonthId) {
            alert(`Select month to reconcile.`, `${this.appInfo.settings.church.toUpperCase()}`);
            return null;
        }
        const assignedMonth = moment(new Date(this.selectedMonthId === 12 ? today.getFullYear() - 1 : today.getFullYear(), this.selectedMonthId - 1, 1)).format('MM/DD/YYYY');
        return assignedMonth;
    }

    async processBankCSV() {
        let results;
        const assignedMonth = this.getAssignedMonth();
        if (!assignedMonth) return;
        if (!this.dataReturned) {
            await alert(`Data has not been loaded.  Select month and press Get Data.`, `${this.appInfo.settings.church.toUpperCase()}`);
            return;
        }

        if (!!this.bankAmounts && this.bankAmounts.length > 0) {
            const result = await confirm(
                `There is bank information already loaded. Do you really want to add more?\r\n(To start over, delete everything first, then add data.`,
                `${this.appInfo.settings.church.toUpperCase()}`
            );
            if (!result) return;
        }

        this.appInfo.pleaseWaitShow();
        try {
            results = (await this.givingService.processBankData(this.bankPath, assignedMonth)) as any;
        } catch (error) {
            this.appInfo.pleaseWaitHide();
            this.appInfo.notifyToast('Please fix errors: ' + error.message, 'error', 5000);
            return;
        }
        if ((!!results && !!results.error) || !results) {
            this.appInfo.pleaseWaitHide();
            this.appInfo.notifyToast('Please fix errors: ' + !!results ? results.error : 'No Date', 'error');
            return;
        }

        results.bankAmounts.forEach((bankAmount) => {
            const entryId = this.bankAmounts.length > 0 ? _.maxBy(this.bankAmounts, 'id').id + 1 : 1;
            const amount = !!bankAmount.credit ? bankAmount.credit : bankAmount.debit ? bankAmount.debit * -1 : 0;
            this.bankAmounts.push({ id: entryId, amount: amount, postDate: moment(bankAmount.postDate).toDate(), description: bankAmount.description });
        });
        await this.getData();
        this.calculateTotals();
        this.appInfo.pleaseWaitHide();
    }

    async processGivingCSV() {
        let results;
        const assignedMonth = this.getAssignedMonth();
        if (!assignedMonth) return;
        this.appInfo.pleaseWaitShow();
        try {
            results = (await this.givingService.processGivingData(this.givingPath, assignedMonth)) as any;
            if (results.error) {
                this.appInfo.pleaseWaitHide();
                await alert(results.error, 'Error');
                return;
            }
        } catch (error) {
            this.appInfo.pleaseWaitHide();
            this.appInfo.notifyToast('Please fix errors: ' + error.message, 'error', 5000);
            return;
        }
        if ((!!results && !!results.error) || !results) {
            this.appInfo.pleaseWaitHide();
            this.appInfo.notifyToast('Please fix errors: ' + !!results ? results.error : 'No Date', 'error');
            return;
        }
        await this.getData();
        this.calculateTotals();
        this.appInfo.pleaseWaitHide();
    }

    async link() {
        const selectedBank = this.bankGrid.instance.getSelectedRowsData()[0];
        const selectedGivings = this.contributionsGrid.instance.getSelectedRowsData();

        if (!selectedBank || !selectedGivings) return;
        let givingsTotal: number = 0;
        selectedGivings.forEach((x) => {
            givingsTotal += x.grossGift;
        });
        givingsTotal = Math.round((givingsTotal + Number.EPSILON) * 100) / 100;

        if (givingsTotal !== selectedBank.amount) {
            const result = await confirm(
                `Selected totals do not match</br>Bank: ${selectedBank.amount}</br>Givings: ${givingsTotal}</br>Do you still want to link?`,
                `Online Batch Creation`
            );
            if (!result) return;
        }

        selectedGivings.forEach((x) => {
            x.bankTransactionId = selectedBank.id;
        });
        this.bankGrid.instance.clearSelection();
        this.contributionsGrid.instance.clearSelection();
        await this.uow.commit();
        await this.getBankAmounts();
    }

    async unLink() {
        const result = await confirm(`Are you sure you want to UnLink all the associated records?`, `${this.appInfo.settings.church.toUpperCase()}`);
        if (!result) return;

        const selectedBank = this.bankGrid.instance.getSelectedRowsData()[0];
        const x = selectedBank;
        if (x.onlineContributions && x.onlineContributions.length > 0) {
            _.forEachRight(x.onlineContributions, (contribution) => {
                contribution.bankTransactionId = null;
            });
        }
        await this.uow.commit();
        await this.getData();
    }

    async assignPerson() {
        const selectedRow = this.contributionsGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow) return;

        const people = await this.uow.getPeopleForGiving();
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Assign Online Donor',
                dialogPrompt: 'Select Donor',
                dialogValueArray: people,
                mode: 'selectWithId',
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success && result.value) {
                const person = (await this.uow.people.byId(result.value)) as any;
                this.contributions.forEach((x) => {
                    if (x.donorId === selectedRow.donorId) x.personId = result.value;
                });
                person.donorId = selectedRow.donorId;
                await this.uow.commit();
                this.contributionsGrid.instance.clearSelection();
            }
            modalRef.hide();
        });
    }

    async validate(): Promise<boolean> {
        let allBankTransactionsAssigned = true;
        this.bankAmounts.forEach((x) => {
            if (x.amount > 0 && x.onlineContributions.length <= 0) allBankTransactionsAssigned = false;
        });
        if (!allBankTransactionsAssigned) {
            await alert(`One or more of the BANK TRANSACTIONS has not been assigned!`, `Error`);
            return false;
        }

        let allDonationMonthsSet = true;
        let peopleAssigned = true;
        let nextMonthSet = true;
        this.contributions.forEach((x) => {
            if (!x.currentMonth && !x.nextMonth) allDonationMonthsSet = false;
            if (x.personId === 0) peopleAssigned = false;
            if (x.currentMonth && !x.bankTransactionId) nextMonthSet = false;
        });
        if (!peopleAssigned) {
            await alert(`One or more of the contributions does not have an ARK person assigned!`, `Error`);
            return false;
        }
        if (!allDonationMonthsSet) {
            await alert(`One or more of the contributions is not included in this month or the next!`, `Error`);
            return false;
        }
        if (!nextMonthSet) {
            await alert(`Unlinked Donations have not been set to Next Month`, `Error`);
            return false;
        }

        if (!this.selectedMonthId) {
            await alert(`Select the month`, `Error`);
            return false;
        }

        if (!this.fee) {
            await alert(`Fee Required`, `Error`);
            return false;
        }
        if (!!this.fee && this.fee >= 0) {
            await alert(`Fee must be NEGATIVE`, `Error`);
            return false;
        }

        this.calculateTotals();
        let bankTotalCheck: number = this.currentMonthTotal + this.fee + this.previousBatch.totalAmount;
        bankTotalCheck = Math.round((bankTotalCheck + Number.EPSILON) * 100) / 100;

        let cloverTotal: number = this.cloverTotal;
        cloverTotal = Math.round((cloverTotal + Number.EPSILON) * 100) / 100;

        let monthTotal = this.currentMonthTotal + this.nextMonthTotal;
        monthTotal = Math.round((monthTotal + Number.EPSILON) * 100) / 100;

        return true;
    }

    async serverSide() {
        const valid = await this.validate();
        if (!valid) {
            this.appInfo.pleaseWaitHide();
            return;
        }
        this.appInfo.pleaseWaitShow();

        await this.uow.commit();

        const today = new Date();
        const yearValue = today.getFullYear();
        this.givingService.createBatchesServerSide(this.selectedMonthId, yearValue, this.fee);

        this.bankAmounts.forEach((x) => {
            x.processed = new Date();
        });
        await this.uow.commit();

        this.appInfo.pleaseWaitHide();
        await this.summary();
        // await this.getData();
        this.bankAmounts = [];
        this.contributions = [];
        this.fee = 0;
        this.bankPath = null;
        this.givingPath = null;
    }

    async save(saveOnly?: boolean) {
        const valid = await this.validate();
        if (!valid) return;

        // check against no next months being set
        // let allDonationMonthsSet = true;
        // this.contributions.forEach((x) => {
        //     if (x.currentMonth && !x.bankTransactionId) allDonationMonthsSet = false;
        // });

        // if (!allDonationMonthsSet) {
        //     const setDonations = await confirm(`Do you want to set the UnLinked donations to next month?`, `${this.appInfo.settings.church}`);
        //     if (setDonations) {
        //         this.contributions.forEach((x) => {
        //             if (x.currentMonth && !x.bankTransactionId) {
        //                 x.nextMonth = true;
        //                 x.currentMonth = false;
        //             }
        //         });
        //         await this.uow.commit();
        //     } else {
        //         return;
        //     }
        // }

        // selected months go from 1-12; ts months go 0-11
        const december = this.selectedMonthId === 12;
        const today = new Date();
        this.yearValue = !!december ? today.getFullYear() - 1 : today.getFullYear();

        const result = await confirm(`Are you ready to create the online batches?`, `Online Batch Creation`);
        if (!result) return;
        this.processing = true;
        this.appInfo.pleaseWaitShow();

        let contributionCount = 0;
        //CURRENT MONTH
        const currentMonth = this.contributions.filter((x) => {
            if (x.currentMonth && !x.contributionId) return x;
        });
        if (currentMonth.length !== 0) {
            const batchId = await this.createBatch(this.selectedMonthId - 1, false);
            currentMonth.forEach((contribution) => {
                const donation = this.uow.manager.createEntity('Contribution', {
                    batchId: batchId,
                    typeId: 4,
                    personId: contribution.personId,
                    note: contribution.note,
                    created: new Date(Date.now()),
                    createdBy: this.auth.currentUser.userName,
                }) as Contribution;
                const donationLine = this.uow.manager.createEntity('ContributionLine', {
                    contributionId: donation.id,
                    accountId: 1,
                    amount: contribution.grossGift,
                    created: new Date(Date.now()),
                    createdBy: this.auth.currentUser.userName,
                }) as ContributionLine;
                contribution.contributionId = donation.id;
                contribution.processed = new Date();

                contributionCount++;
            });
        }
        await this.uow.commit();

        //FEE
        const batchId = await this.createBatch(this.selectedMonthId - 1, false, true);
        const donation = this.uow.manager.createEntity('Contribution', {
            batchId: batchId,
            typeId: 4,
            personId: 3794,
            created: new Date(Date.now()),
            createdBy: this.auth.currentUser.userName,
        }) as Contribution;
        const donationLine = this.uow.manager.createEntity('ContributionLine', {
            contributionId: donation.id,
            accountId: 1,
            amount: this.fee,
            created: new Date(Date.now()),
            createdBy: this.auth.currentUser.userName,
        }) as ContributionLine;
        await this.uow.commit();

        //NEXT MONTH
        // If the month is december, the donations get put in the current year
        const nextMonth = this.contributions.filter((x) => {
            if (x.nextMonth && !x.contributionId) return x;
        });
        if (nextMonth.length !== 0) {
            const nextBatchId = await this.createBatch(this.selectedMonthId, true, null, december);
            nextMonth.forEach((contribution) => {
                const donation = this.uow.manager.createEntity('Contribution', {
                    batchId: nextBatchId,
                    typeId: 4,
                    personId: contribution.personId,
                    note: contribution.note,
                    created: new Date(Date.now()),
                    createdBy: this.auth.currentUser.userName,
                }) as Contribution;
                const donationLine = this.uow.manager.createEntity('ContributionLine', {
                    contributionId: donation.id,
                    accountId: 1,
                    amount: contribution.grossGift,
                    created: new Date(Date.now()),
                    createdBy: this.auth.currentUser.userName,
                }) as ContributionLine;

                contribution.contributionId = donation.id;
                contribution.processed = new Date();

                contributionCount++;
            });
        }
        await this.uow.commit();

        // If last month of the year, there needs to be (2) batches for the next year to offset moving the giving to the current year.

        if (december) {
            // NEGATIVE DECEMBER BATCH
            let cancelYear = today.getFullYear() - 1;
            let batchDate = moment(new Date(cancelYear, 11, 31)).toDate(); //ts dates go from 0-11 (11 is december)
            let batchMonth = 'December';

            const cancelDecemberBatch = this.uow.contributionBatches.createEntity();
            cancelDecemberBatch.created = new Date();
            cancelDecemberBatch.createdBy = this.auth.currentUser.userName;
            cancelDecemberBatch.date = batchDate;
            cancelDecemberBatch.name = `12/31/${cancelYear}- December Monthly Online Giving - Cancel batch for credit in December, deposit in January`;
            cancelDecemberBatch.specialAccountId = 1;
            cancelDecemberBatch.statusId = 3;

            const cancelDecemberDonation = this.uow.manager.createEntity('Contribution', {
                batchId: cancelDecemberBatch.id,
                typeId: 4,
                personId: 3794,
                created: new Date(Date.now()),
                createdBy: this.auth.currentUser.userName,
            }) as Contribution;
            const cancelDecemberDonationLine = this.uow.manager.createEntity('ContributionLine', {
                contributionId: cancelDecemberDonation.id,
                accountId: 1,
                amount: this.nextMonthTotal * -1,
                created: new Date(Date.now()),
                createdBy: this.auth.currentUser.userName,
            }) as ContributionLine;

            //JANUARY BATCH, positive batch to OtherPayment so ARK and QB tie out year to year
            cancelYear = today.getFullYear();
            batchDate = moment(new Date(cancelYear, 0, 1)).toDate();
            batchMonth = 'January';

            const cancelBatch = this.uow.contributionBatches.createEntity();
            cancelBatch.created = new Date();
            cancelBatch.createdBy = this.auth.currentUser.userName;
            cancelBatch.date = batchDate;
            cancelBatch.name = `01/01/${cancelYear}- January Monthly Online Giving from Last Year - OtherPayment Only`;
            cancelBatch.specialAccountId = 1;
            cancelBatch.statusId = 3;

            const cancelDonation = this.uow.manager.createEntity('Contribution', {
                batchId: cancelBatch.id,
                typeId: 4,
                personId: 3794,
                created: new Date(Date.now()),
                createdBy: this.auth.currentUser.userName,
            }) as Contribution;
            const cancelDonationLine = this.uow.manager.createEntity('ContributionLine', {
                contributionId: cancelDonation.id,
                accountId: 1,
                amount: this.nextMonthTotal,
                created: new Date(Date.now()),
                createdBy: this.auth.currentUser.userName,
            }) as ContributionLine;

            await this.uow.commit();
        }

        this.bankAmounts.forEach((x) => {
            x.processed = new Date();
        });
        await this.uow.commit();

        this.appInfo.pleaseWaitHide();
        await alert(`Contributions recorded!  ${contributionCount}`, `GRAAFSCHAP`);
        this.bankAmounts = [];
        this.contributions = [];
        // this.router.navigate(['/giving/batches']);
        // this.result.next({ result: true });
        // this.modalRef.hide();
    }

    async createBatch(month: number, nextMonth: boolean, fee?: boolean, endOfYear?: boolean, selectedMonthId?: number): Promise<number> {
        const today = new Date();
        const monthIntValue = month + 1;
        // console.log('month', month);
        // console.log('monthValue', monthIntValue);
        // console.log('12', moment(12, 'M').daysInMonth());
        // console.log('11', moment(11, 'M').daysInMonth());

        const batchDate = moment(new Date(this.yearValue, month, nextMonth ? 1 : moment(monthIntValue, 'M').daysInMonth()))
            .add(nextMonth ? 0 : 0, 'days')
            .toDate();
        const batchMonth = !nextMonth ? moment(batchDate).format('MMMM') : moment(batchDate).add(-1, 'month').format('MMMM');
        // console.log('batchDate', batchDate);
        // console.log('batchMonth', batchMonth);

        const batch = this.uow.contributionBatches.createEntity();
        batch.created = today;
        batch.createdBy = this.auth.currentUser.userName;
        batch.date = !endOfYear ? batchDate : new Date(this.yearValue, 11, 31);
        batch.name = `${moment(batch.date).format('MM/DD/YYYY')} - ${batchMonth} Monthly Online Giving${
            !nextMonth ? (fee ? ' Fee' : '') : ' Carryover into ' + moment(batchDate).format('MMMM')
        }`;
        batch.specialAccountId = 1;
        batch.statusId = 3;
        await this.uow.commit();
        return batch.id;
    }

    async cancel() {
        if (this.contributions.length !== 0) {
            const dialogResult = await (<Promise<boolean>>confirm('Are you sure you want to cancel?  All changes will be lost!', 'Confirm Cancel'));
            if (!dialogResult) return;
        }
        this.bankAmounts = [];
        this.contributions = [];
        sessionStorage.setItem('bankAmounts', JSON.stringify([]));
        sessionStorage.setItem('contributions', JSON.stringify([]));
        this.uow.rollback();
        // this.router.navigate(['/giving/batches']);
    }

    async uploadStarted() {
        // await this.uow.commit();
        // this.key = this.message.id;
    }
    async attachmentUploaded(mode: string) {
        const attachment = (await this.uow.getGivingFilePath(mode)) as any;
        attachment.createdBy = this.auth.currentUser.userName;
        await this.uow.commit();
        const filePath = attachment.filename;
        if (mode === 'Clover') this.givingPath = filePath;
        else this.bankPath = filePath;
    }

    async summary(): Promise<boolean> {
        this.calculateTotals();
        const modalRef = this.modalService.show(OnlineSummaryDialogComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                amounts: {
                    bankAmount: this.bankTotal,
                    currentMonth: this.currentMonthTotal,
                    nextMonth: this.nextMonthTotal,
                    lastMonth: this.lastMonthTotal,
                    fee: this.fee,
                    contributions: this.contributions,
                },
                contributions: this.contributions,
                selectedMonth: this.selectedMonthId,
            },
        });

        const promise = new Promise<boolean>(async (resolve, reject) => {
            modalRef.content.result.subscribe(async (result) => {
                if (result.success) {
                    resolve(true);
                }
                modalRef.hide();
                // resolve(true);
            });
        });
        return promise;
    }
}
class ContributionItem {
    id: number;
    givingTypeId: number;
    givingName: string;
    personName: string;
    personId: number;
    amount: number;
    envelope: any;
    note: any;
    thisMonth: boolean;
    nextMonth: boolean;
    donationDate: Date;
    batchId: number;

    constructor() {}
}
